import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SchedulerCourseList from "./SchedulerCourseList";
import Loading from "../../UI/Loading/Loading";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
const CourseSchedulerSidebar = ({ getColorOfCourse, getColorOfCourseGroup, onSelectedCourseSectionsChange, courses, loadingCourseIds, loadedCourseIds, loadCourse, courseSections, groups, groupMap, selectedCourseSections, selectedLocations, otherScheduledItems, }) => {
    if (courses.isLoading) {
        return (_jsx("div", { className: "d-flex w-100 pt-3 justify-content-center", children: _jsx(Loading, { size: "2x" }) }));
    }
    if (courses.hasError) {
        // Show error;
        return (_jsx("div", { className: "p-3", children: _jsx(AlertError, { message: "There was an error loading your courses", detail: courses.errorMessage }) }));
    }
    if (courses.data && courses.data.length) {
        return (_jsx(SchedulerCourseList, { courses: courses.data || [], loadingCourseIds: loadingCourseIds, loadedCourseIds: loadedCourseIds, loadCourse: loadCourse, sections: courseSections.data || [], groups: groups.data || [], groupMap: groupMap, onSelectedCourseSectionsChange: onSelectedCourseSectionsChange, selectedCourseSections: selectedCourseSections, 
            // @ts-expect-error - TS2322 - Type '(arg1: number) => string | null | undefined' is not assignable to type '(arg1: string) => string | null | undefined'.
            getColorOfCourse: getColorOfCourse, getColorOfCourseGroup: getColorOfCourseGroup, selectedLocations: selectedLocations, otherScheduledItems: otherScheduledItems }));
    }
    if (courses.wasSuccessful && (!courses.data || !courses.data.length)) {
        return _jsx("div", { className: "p-3 text-center", children: "No Courses Found" });
    }
    return null;
};
export default CourseSchedulerSidebar;
